import React from 'react'
import { generatePath, NavLink } from 'react-router-dom'
import { useParams } from 'react-router'
import get from 'lodash/get'
import classnames from 'classnames'
import { format } from 'date-fns'
import { KIT_STATUS } from '../List/constants'
import style from './KitReportDetails.module.css'
import { LAB_REPORTS, CLIENTS } from '../../../config/routes'
import FancyID from '../../../components/Utils/FancyID'
import capitalize from '../../../utils/capitalize'
import DocumentsDetails from '../../../components/ReportDetails/DocumentsDetails'

const LabOrderProviders = ({ details }) => (
  <span>{details.map((detail) => detail.producerId).join(', ')}</span>
)

export default function KitReportDetails({ labOrder, refetch }) {
  const { kitId } = useParams()

  if (!kitId) return null

  // get kit details for kit orders
  const { kits } = labOrder
  const { kit, tracking } =
    kits.length && kits.find(({ kit }) => kit.id === kitId)

  // get the status of the last tracking entry
  const latest = tracking.at(-1)
  const status = latest.status.toUpperCase()

  const clientId = get(labOrder, 'patient.id')
  const orderedDate = format(new Date(labOrder.createdAt), 'MMM d, yyyy')

  return (
    <section className={style.container} data-test="lab-report-profile">
      <h1 className={style.name}>{kit.name}</h1>
      <span className={style.detailsItem}>
        Report ID:&nbsp;
        <NavLink
          to={generatePath(LAB_REPORTS.view, { labReportId: labOrder.id })}
        >
          <FancyID id={labOrder.id} />
        </NavLink>
      </span>
      {labOrder.summary && (
        <div className={style.summary}>
          <div className={classnames(style.summaryValue, style.summaryNormal)}>
            {get(labOrder, 'summary.normal', 0)}
          </div>
          <div
            className={classnames(style.summaryValue, style.summaryAbnormal)}
          >
            {get(labOrder, 'summary.abnormal', 0)}
          </div>
        </div>
      )}
      <span className={style.detailsItem}>
        Patient:{' '}
        <NavLink to={generatePath(CLIENTS.view, { clientId })}>
          {get(labOrder, 'patient.data.name.display')}
        </NavLink>
      </span>
      <span className={style.detailsItem}>
        {(labOrder.providerDetails && labOrder.providerDetails.length && (
          <div>
            Lab(s): <LabOrderProviders details={labOrder.providerDetails} />{' '}
            <br />
          </div>
        )) ||
          null}
      </span>
      <span className={style.detailsItem}>Ordered: {orderedDate}</span>
      {status && (
        <span className={style.detailsItem}>
          Status:{' '}
          <span
            className={classnames('ui', 'small', 'label', {
              violet: status === KIT_STATUS.DEFAULT,
              blue: status === KIT_STATUS.SHIPPED,
              brown: status === KIT_STATUS.COLLECTED,
              green: status === KIT_STATUS.RETURN,
              pink: status === KIT_STATUS.RECEIVED,
              orange: status === KIT_STATUS.ORDERED,
            })}
            style={{
              textTransform: 'capitalize',
            }}
          >
            {capitalize(status)}
          </span>
        </span>
      )}
      {labOrder.resultViewed.date && (
        <span className={style.detailsItem}>
          Viewed:{' '}
          {format(new Date(labOrder.resultViewed.date), 'MMM dd, yyyy hh:mm a')}
        </span>
      )}
      {labOrder.resultReviewed.date && (
        <span className={style.detailsItem}>
          Reviewed:{' '}
          {format(
            new Date(labOrder.resultReviewed.date),
            'MMM dd, yyyy hh:mm a',
          )}
        </span>
      )}
      {labOrder.resultReviewed.date && (
        <span className={style.detailsItem}>
          Reviewed by: {labOrder.resultReviewed?.by?.name?.display}
        </span>
      )}

      <DocumentsDetails labOrder={labOrder} refetch={refetch} />
    </section>
  )
}
